import { __BROWSER__ } from '../env';
import { natural } from './compare';

export const bind = (naturalInsensitive?, naturalDateFormat?, naturalLocale?) => {
  if (__BROWSER__) {
    window._.mixin({
      uuid: () => {
        /* eslint-disable no-bitwise */
        let d = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
        /* eslint-enable no-bitwise */
      },
      isUuid: (obj) => obj?.length === 36,
      sortNatural: (obj, val, ctx) => {
        if (naturalInsensitive === true) {
          natural.insensitive = true;
        }
        if (naturalDateFormat) {
          natural.dateFormat = naturalDateFormat;
        }
        if (naturalLocale) {
          natural.locale = naturalLocale;
        }
        const iterator = _.isFunction(val)
          ? val
          : (o) => (String(val).indexOf('()') > -1 ? o[val.replace('()', '')]() : o[val]);
        return _.map(
          _.map(obj, (value, index, list) => ({
            value,
            index,
            criteria: iterator.call(ctx, value, index, list)
          })).sort((left, right) => natural(left.criteria, right.criteria)),
          'value'
        );
      }
    });
  }
};

export default {
  bind
};
